import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Показатель',
    key: 'var_code',
    width: 250,
  },
  {
    title: 'Описание показателя',
    key: 'var_text',
    width: 250,
  },
];
